import * as React from 'react';
import { SVGProps } from 'react';
const SvgHome = ({
  width = 24,
  height = 24,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="#000"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.00044 22.0002H8.99995H14.9999H20.9999V13.0003L22.4143 12L12.0008 1.58806C11.6098 1.19706 11.9999 1.58721 11.9999 1.58721L1.5 12L3.00044 13.0003V22.0002ZM9.99995 20.0002V15.0002H13.9999V20.0002H9.99995ZM4.99995 11.4143L11.9999 4.41437L18.9999 11.4143L19.0009 20.0002H15.9999V13.0003H7.99995V20.0002H4.99995V11.4143Z"
      fill="current"
    />
  </svg>
);
export default SvgHome;
